import React from 'react';
import './companyInfo.css'
import Logo from './logo.gif'
import coursel1 from './coursel-1.jpg'
import coursel2 from './coursel-2.jpg'
import coursel3 from './coursel-3.jpg'
import brand1 from './Wallet.png'
import brand2 from './EaseWedding.png'
import brand3 from './EntwicklersX.png'
import subscribe from './subscribe.svg'
import clickhand from './clickhand.svg'

export const CompanyInfo = () => {
  return <div id='companyInfo' className='companyInfo'>
      <div className="companyOverview">
          <img src={Logo} alt="yellowLogo" />
          <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatum Nemo aperiam, reiciendis quasi harum cum praesentium blanditiis. Blanditiis ullam distinctio alias amet! Unde nobis sit odio, similique itaque, a quas mollitia commodi aliquid distinctio tempora.</p>
          <span className="knowmore">Know more ></span>
      </div>

      <div id="testimonials" class="carousel carousel-dark slide" data-bs-ride="carousel">
      <div class="carousel-indicators">
        <button type="button" data-bs-target="#testimonials" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
        <button type="button" data-bs-target="#testimonials" data-bs-slide-to="1" aria-label="Slide 2"></button>
        <button type="button" data-bs-target="#testimonials" data-bs-slide-to="2" aria-label="Slide 3"></button>
      </div>
      <div class="carousel-inner">
        <div class="carousel-item active" data-bs-interval="2000">
          <img src={coursel1} class="d-block w-100" alt="..."></img>
          <div class="carousel-caption d-none d-md-block">
          </div>
        </div>
        <div class="carousel-item" data-bs-interval="2000">
          <img src={coursel2} class="d-block w-100" alt="..."></img>
          <div class="carousel-caption d-none d-md-block">
          </div>
        </div>
        <div class="carousel-item" data-bs-interval="3000">
          <img src={coursel3} class="d-block w-100" alt="..."></img>
          <div class="carousel-caption d-none d-md-block">
          </div>
        </div>
      </div>
      <button class="carousel-control-prev" type="button" data-bs-target="#testimonials" data-bs-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </button>
      <button class="carousel-control-next" type="button" data-bs-target="#testimonials" data-bs-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </button>
    </div>

    <div className="brandsLogo">
      <img src={brand1} alt="EntwicklersX" />
      <img src={brand2} alt="EntwicklersX" />
      <img src={brand3} alt="EntwicklersX" />
    </div>
    <hr />
    <div className="subscribe">
      <img className='laptopScreen' src={subscribe} alt="Subscribe" />
      <form action="/" method="post">
        <input type="email" name="email" placeholder='Enter Your Email Address' id="email" /><br />
        <button>Subscribe! <i class="fas fa-bell"></i></button>
      </form>
      <img className='clickHand' src={clickhand} alt="Click" />
    </div>
  </div>;
};
